import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=5fd6b892&"
import script from "./RatingStar.vue?vue&type=script&lang=ts&"
export * from "./RatingStar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports